//Libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import Grid from '@material-ui/core/Grid';
//Componentes
import ImageInput from '../ImageInput';
//Modelos
import AvaliacaoResposta from '../../models/AvaliacaoResposta';
//Úteis
import formatarUrlImagem from '../../utils/formatarUrlImagem';


/**
 * Componente para renderizar um campo para responder uma questão do tipo foto
 */
class AvaliacaoRespostaImagem extends Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleRespostaChange = this.handleRespostaChange.bind(this);
        this.handleImagemError = this.handleImagemError.bind(this);
        //Estado inicial
        this.state = {
            mensagemErro: ''
        };
    }

    /**
     * Atualiza a resposta de acordo com o que foi selecionado pelo usuário
     * @param {*} target Componente que disparou o evento
     * @param {String} imagem Nova imagem selecionada
     */
    handleRespostaChange(target, imagem) {
        //Cria uma cópia da imagem
        const questao = AvaliacaoResposta.clone(this.props.questao);
        //Atualiza a resposta
        questao.novaImagem = imagem;
        //Dispara o evento de alteração
        if (this.props.onChange)
            this.props.onChange(questao);
        //Limpa a mensagem de erro
        this.setState({ mensagemErro: '' });
    }

    /**
     * Retorna a imagem de erro ao selecionar uma imagem
     * @param {*} target Componente que disparou o evento
     * @param {*} mensagemErro Mensagem de erro
     */
    handleImagemError(target, mensagemErro) {
        //Atualiza o estado do componente
        this.setState({ mensagemErro });
    }

    render() {

        /** @type {AvaliacaoResposta} */
        const questao = this.props.questao;
        //Identifica a mensagem de erro que deve ser exibida (o estado tem preferência)
        let mensagemErro = '';
        if (this.state.mensagemErro)
            mensagemErro = this.state.mensagemErro;
        else if (this.props.erro.erroResposta)
            mensagemErro = this.props.erro.erroResposta;
        else 
            mensagemErro = this.props.erro.resposta;

        //Caso já possua uma resposta preenchida, é colocada no placeholder
        let imagePlaceholder = '';
        if (questao.resposta)
            imagePlaceholder = formatarUrlImagem(questao.resposta);

        return (
            <Grid item xs={12} >
                <ImageInput
                    name="resposta"
                    label={questao.titulo}
                    onChange={this.handleRespostaChange}
                    onError={this.handleImagemError}
                    placeholder={imagePlaceholder}
                    value={questao.novaImagem}
                    errorMessage={mensagemErro}
                />
            </Grid>
        );
    }
}

AvaliacaoRespostaImagem.propTypes = {
    /** Objeto contendo os dados da questão a ser respondida */
    questao: PropTypes.instanceOf(AvaliacaoResposta).isRequired,
    /** Evento disparado quando a resposta for alterada */
    onChange: PropTypes.func,
    /** Mensagens de erro da resposta */
    erro: PropTypes.shape({ 
        resposta: PropTypes.string,
        erroResposta: PropTypes.string
    }),
};

AvaliacaoRespostaImagem.defaultProps = {
    erro: {
        resposta: '',
        erroResposta: ''
    }
};

export default AvaliacaoRespostaImagem;